var userAgent = window.navigator.userAgent.toLowerCase();

export default {
    version: (userAgent.match(
        /.+(?:me|ox|on|rv|it|era|opr|ie)[\/: ]([\d.]+)/
    ) || [0, '0'])[1],
    opera: /opera/i.test(userAgent) || /opr/i.test(userAgent),
    is_msie: (() => {
        var rv = -1;

        if (navigator.appName === 'Microsoft Internet Explorer') {
            const ua = navigator.userAgent;
            const re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');

            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        } else if (navigator.appName === 'Netscape') {
            const ua = navigator.userAgent;
            const re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');

            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }

        return rv === -1 ? false : true;
    })(),
    edge: /edge/i.test(userAgent),
    msie:
        (/msie/i.test(userAgent) && !/opera/i.test(userAgent)) ||
        /trident\//i.test(userAgent),
    msie6: /msie 6/i.test(userAgent) && !/opera/i.test(userAgent),
    msie7: /msie 7/i.test(userAgent) && !/opera/i.test(userAgent),
    msie8: /msie 8/i.test(userAgent) && !/opera/i.test(userAgent),
    msie9: /msie 9/i.test(userAgent) && !/opera/i.test(userAgent),
    mozilla: /firefox/i.test(userAgent),
    chrome: /chrome/i.test(userAgent),
    safari:
        !/chrome/i.test(userAgent) && /webkit|safari|khtml/i.test(userAgent),
    iphone: /iphone/i.test(userAgent),
    ipod: /ipod/i.test(userAgent),
    iphone4: /iphone.*OS 4/i.test(userAgent),
    ipod4: /ipod.*OS 4/i.test(userAgent),
    ipad: /ipad/i.test(userAgent),
    android: /android/i.test(userAgent),
    bada: /bada/i.test(userAgent),
    mobile: /iphone|ipod|ipad|opera mini|opera mobi|iemobile|android/i.test(
        userAgent
    ),
    msie_mobile: /iemobile/i.test(userAgent),
    safari_mobile: /iphone|ipod|ipad/i.test(userAgent),
    opera_mobile: /opera mini|opera mobi/i.test(userAgent),
    opera_mini: /opera mini/i.test(userAgent),
    mac: /mac/i.test(userAgent),
    search_bot:
        /(yandex|google|stackrambler|aport|slurp|msnbot|bingbot|twitterbot|ia_archiver|facebookexternalhit)/i.test(
            userAgent
        ),
};
